export default {
      id: "close-usage",
      viewBox: "0 0 24 24",
      url: "/img/" + "sprite.svg#close",
      toString: function () {
        return this.url;
      }
    }